import { render, staticRenderFns } from "./EmailMarketing.vue?vue&type=template&id=1f5fd60c&"
import script from "./EmailMarketing.vue?vue&type=script&lang=js&"
export * from "./EmailMarketing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f5fd60c')) {
      api.createRecord('1f5fd60c', component.options)
    } else {
      api.reload('1f5fd60c', component.options)
    }
    module.hot.accept("./EmailMarketing.vue?vue&type=template&id=1f5fd60c&", function () {
      api.rerender('1f5fd60c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Configuration/EmailMarketing/EmailMarketing.vue"
export default component.exports